// Central registry of every live EventSource the app has open.
//
// Why this exists: an SSE stream is authenticated only at the handshake, so once connected it keeps
// delivering until something calls es.close(). Component unmount does that — but on logout the
// unmount races a hard navigation and isn't guaranteed to run first, which left live-location /
// metrics streams hanging open on a session we'd already abandoned. Auth teardown needs to cut them
// deterministically, not hope the React cleanup wins the race, so every stream registers here and
// closeAllStreams() shuts them all synchronously.

const open = new Set();

/** Track a freshly-opened EventSource. Returns an unregister fn to call when it closes normally. */
export function registerStream(es) {
  open.add(es);
  return () => open.delete(es);
}

/** Force every registered stream shut. Safe to call repeatedly; a closed EventSource ignores close(). */
export function closeAllStreams() {
  for (const es of open) {
    try { es.close(); } catch (_) { /* already gone */ }
  }
  open.clear();
}